<!-- <app-home-banner></app-home-banner> -->
<section class="banner">
  <div class="bann-image">
    <img src="../../../../../assets/images/abot-banner.jpg">

    <div class="testimonial">
      <div class="testimonial-content">
        <h2 class="title">
          About
        </h2>
        <h1>
          Narmetta as Model Village
        </h1>
        <p class="description">
          This is a list of indian state and terrtories ranked by their househlods with open<br>
          defection fees in both urban abd rueal areas.Figuers are form the ministry of drinking<br> water and
          sanitation. The below tableshows ODF(Open Defecation free), househlods <br>with toilets as a percentage of the
          total
          population
        </p>
        <div class="buttons-baner" fxLayout="row" fxLayoutAlign="center center">
          <button class="btn btn-sm read-btn" mat-button
            [routerLink]="['/government_offices_settings/community_water_supplys']">About Narmetta</button>
          <button class="btn btn-sm mor-btn" mat-button
            [routerLink]="['/government_offices_settings/community_water_supplys']">Contact Narmetta</button>
        </div>
      </div>
    </div>
    <div class="overlay"></div>

  </div>
</section>
<section class="innerpage navigations">
  <div class="wrapper">
    <div class="swiper-button-prev initiatives-button-prev">
      <img src="../../../../../assets/images/ic/left-arrow.svg" alt="" srcset="">
    </div>
    <div class="swiper-container" [swiper]="config">


      <div class="swiper-wrapper">

        <div class="swiper-slide" [ngClass]="{'custom-active-slide': singleSection.id === selectedSectionId}"
          *ngFor="let singleSection of sections">
          <div class="card_box">
            <a [routerLink]="['../', singleSection.id]" queryParamsHandling="merge">
              <div class="card_img">
                <img [src]="aboutVillage[singleSection.id].image.url">
              </div>
              <div class="card_conent">
                <h5 *ngIf="lang==='en'" [innerHtml]="aboutVillage[singleSection.id].en_title"> </h5>
                <h5 *ngIf="lang==='te'" [innerHtml]="aboutVillage[singleSection.id].te_title"> </h5>
              </div>
            </a>
          </div>
          <div class="banner_overlay"></div>
        </div>

      </div>
    </div>
    <div class="swiper-button-next initiatives-button-next">
      <img src="../../../../../assets/images/ic/right-arrow.svg" alt="" srcset="">
    </div>

  </div>
</section>
<ng-container *ngIf="selectedSectionId === 'profile'; else contentSectionTemplate">
  <section class="about-sect">
    <div class="wrapper">
      <div class="custom_heading">
        <!-- <p>Narmetta</p> -->
        <h2> Village Profile</h2>
      </div>
      <div class="profile-content">

        <p>Narmetta is a reformist village, located in the district or siddipet. As one of the most promising villages
          of telengana state,Narmetta is experiencing the mulitdimensional devlepoment with all faclities and
          infrastrutre
        </p>
        <img src="../../../../../assets/images/purified.png" alt="important_document_1">
        <p>Narmetta has a population of about <span>3445</span>persons living in <span>633</span>houses,Narmetta is
          aprocess village with the most idealistic version towards Comphershive development. The villages and
          representative of grampanchayat are Cohesively working to make it a model m village across Telangana</p>
        <div class="abt-data">
          <p>
            Narmetta is situated at 17.88390 degrees north Latitude.79.159970 degree East Longitude, is at an elevation
            of 380 meters above sea level. Narmetta is located at 16 Kms distance from the district headquarter
            siddipet, and 116 km from the state capital Hyderabad
          </p>
        </div>
      </div>
    </div>
    <div class="village-perf" *ngIf="selectedSectionId === 'profile'">
      <div class="custom_heading">
        <h2>NARMETTA VILLAGE IS MARCHING A HEAD TO ACCOMPLISH PERFORMANCE IN THE FOLLOWING</h2>
      </div>
      <div class="wrapper">
        <div class="village_about" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="start stretch">

          <div class="about-point" fxLayout="column" fxFlex.xl="40" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill fxLayoutAlign="end end">
            <div class="check">
              <p>Passports Issued <img src="../../../../../assets/images/ticks.png"></p>
              <p>Health Insured<img src="../../../../../assets/images/ticks.png"></p>
              <p>Health profile is managed as 'E medial Floder'<img
                  src="../../../../../assets/images/ticks.png"></p>
              <p>Screening<img src="../../../../../assets/images/ticks.png"></p>
              <p>Vehicle Renewals<img src="../../../../../assets/images/ticks.png"></p>
              <p>Open Defecation Free Village<img src="../../../../../assets/images/ticks.png"></p>
              <p>Organic Farming<img src="../../../../../assets/images/ticks.png"></p>
              <p>Cattle Entry Free Village<img src="../../../../../assets/images/ticks.png"></p>
              <p>Bio-conserved Village<img src="../../../../../assets/images/ticks.png"></p>
              <p>BioDiversity Model village<img src="../../../../../assets/images/ticks.png"></p>
              <p>House Geotagged<img src="../../../../../assets/images/ticks.png"></p>
              <p>Farm and Dairy Animals Getotagged<img src="../../../../../assets/images/ticks.png"></p>
              <p>Houses with safe drinking water facility<img src="../../../../../assets/images/ticks.png"></p>
              <p>Pension For all  eligible beneficiaries<img src="../../../../../assets/images/ticks.png"></p>
              <p>Accessibility  Friendly offices<img src="../../../../../assets/images/ticks.png"></p>
              <p>Agricultures Centred Village<img src="../../../../../assets/images/ticks.png"></p>
            </div>
          </div>
          <div class="about-point" fxLayout="column" fxFlex.xl="30" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="100"
            fxFlex.xs="100" fxFlexFill fxLayoutAlign="center center">
            <div class="perct">
              <h2>100%</h2>
            </div>
            <div class="perct">
              <h2>ZERO</h2>
            </div>
            <div class="perct">
              <h2>FIRST</h2>
            </div>
          </div>
          <div class="about-points" fxLayout="column" fxFlex.xl="30" fxFlex.lg="33" fxFlex.md="33" fxFlex.sm="100"
            fxFlex.xs="100">
            <div class="check">

              <div class="pints">
                <p><img src="../../../../../assets/images/ticks.png">Crime Rate</p>
                <p><img src="../../../../../assets/images/ticks.png">Land Disputes</p>
                <p><img src="../../../../../assets/images/ticks.png">Carbon Emission - Certified by (Environment Report)
                </p>
              </div>
              <div class="pinos">
                <p><img src="../../../../../assets/images/ticks.png">Animal Hostel</p>
                <p><img src="../../../../../assets/images/ticks.png">Dairy Animal Hostel</p>
                <p><img src="../../../../../assets/images/ticks.png">Accomplished 1:100 Plantation Drive</p>
                <p><img src="../../../../../assets/images/ticks.png">Village With digitally managed solar LED lights</p>
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>

  </section>
</ng-container>
<ng-template #contentSectionTemplate>
  <section class="about-sect">
    <div class="wrapper">
      <div class="custom_heading">

        <h2 [innerHtml]="selectedSection.en_title"> </h2>
      </div>
      <div class="profile-content">

        <ng-container *ngIf="lang === 'en'; else teluguTemplate">
          <div [innerHtml]="selectedSection.en_content"></div>
        </ng-container>
        <ng-template #teluguTemplate>
          <div [innerHtml]="selectedSection.te_content"></div>
        </ng-template>
      </div>
    </div>
  </section>
</ng-template>
